import type { ValueType } from './types'

export interface AttributeConfig {
  label: string
  operatorLabel: string
  operatorOptions?: { label: string; value: string; resultLabel?: string }[]
  valueType: ValueType
  valueTypeByOperator?: Record<string, ValueType>
}

export const PRODUCT_ATTRIBUTE_CONFIG: Record<string, AttributeConfig> = {
  name: {
    label: 'Name',
    operatorLabel: 'contains',
    operatorOptions: [
      { label: 'contains', value: 'contains' },
      { label: 'does not contain', value: 'not_contains' },
    ],
    valueType: 'text',
  },
  category: {
    label: 'Category',
    operatorLabel: 'is any of',
    valueType: 'multi-category',
  },
  product_code: {
    label: 'Product Code',
    operatorLabel: 'contains',
    operatorOptions: [
      { label: 'contains', value: 'contains' },
      { label: 'does not contain', value: 'not_contains' },
    ],
    valueType: 'text',
  },
  brand: {
    label: 'Brand',
    operatorLabel: 'is any of',
    valueType: 'multi-brand',
  },
  barcode: {
    label: 'Barcode',
    operatorLabel: 'contains',
    operatorOptions: [
      { label: 'contains', value: 'contains' },
      { label: 'does not contain', value: 'not_contains' },
      { label: 'exist', value: 'has' },
      { label: "doesn't exist", value: 'has_not' },
    ],
    valueType: 'text',
    valueTypeByOperator: { has: 'none', has_not: 'none' },
  },
  tags: { label: 'Tags', operatorLabel: 'is', valueType: 'multi-tag' },
  position: {
    label: 'Position',
    operatorLabel: 'is',
    valueType: 'multi-position',
  },
  matching: {
    label: 'Matching',
    operatorLabel: 'is',
    valueType: 'select-match',
  },
  // TODO: backend not ready — uncomment when data is available
  // product_index: {
  //   label: 'Index',
  //   operatorLabel: 'between',
  //   valueType: 'number-range',
  // },
  my_price: {
    label: 'My Price',
    operatorLabel: 'between',
    operatorOptions: [
      { label: 'between', value: 'between' },
      { label: 'is not between', value: 'not_between' },
    ],
    valueType: 'number-range',
  },
  my_product_cost: {
    label: 'My Product Cost',
    operatorLabel: 'between',
    valueType: 'number-range',
  },
  my_total_price: {
    label: 'My Total Price',
    operatorLabel: 'between',
    valueType: 'number-range',
  },
  my_change: {
    label: 'My Price Change',
    operatorLabel: 'is',
    valueType: 'select-change',
  },
  my_stock: {
    label: 'My Stock',
    operatorLabel: 'is',
    valueType: 'select-stock',
  },
  favorites_only: {
    label: 'Favorites Only',
    operatorLabel: 'is',
    valueType: 'select-favorites',
  },
  my_url_status: {
    label: 'My URL Status',
    operatorLabel: 'has',
    valueType: 'select-url-status',
  },
  my_ismine: {
    label: 'My Own URL',
    operatorLabel: 'exists',
    operatorOptions: [
      { label: 'exists', value: 'has' },
      { label: "doesn't exist", value: 'has_not' },
    ],
    valueType: 'none',
  },
}

export const COMPETITOR_ATTRIBUTE_CONFIG: Record<string, AttributeConfig> = {
  competitor: {
    label: 'Competitor',
    operatorLabel: 'is',
    valueType: 'multi-company',
  },
  competitor_price: {
    label: 'Price',
    operatorLabel: 'between',
    operatorOptions: [
      { label: 'between', value: 'between' },
      { label: 'is not between', value: 'not_between' },
    ],
    valueType: 'number-range',
  },
  competitor_total_price: {
    label: 'Total Price',
    operatorLabel: 'between',
    valueType: 'number-range',
  },
  competitor_change: {
    label: 'Price Change',
    operatorLabel: 'is',
    valueType: 'select-change',
  },
  competitor_stock: {
    label: 'Stock',
    operatorLabel: 'is',
    valueType: 'select-stock',
  },
  competitor_url_status: {
    label: 'URL Status',
    operatorLabel: 'has',
    valueType: 'select-url-status',
  },
}
